import { render, staticRenderFns } from "./vsCard.vue?vue&type=template&id=32732618&"
import script from "./vsCard.vue?vue&type=script&lang=js&"
export * from "./vsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsCard.vue"
export default component.exports